import React from 'react'

function RangerWrapper(props) {
    
    const handleInputChange = (evt) => {
        const value = evt.target.value;
        props.onChange(value);
    }

    return (
        <div className='section-container' >
            {props.children}
        </div>
        
    )
}

export default RangerWrapper